/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
import ImageLoad from './ImageLoad';
import { useTranslation } from 'react-i18next';

const CustomPrevArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="bg-gray-200 p-[7px] rounded-[50px] absolute z-10 right-[45px] max-_430_:-top-[55px] -top-[34px] transform -translate-y-1/2 cursor-pointer">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
    </svg>
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="bg-gray-200 p-[7px] rounded-[50px] absolute z-10 right-[0px] max-_430_:-top-[55px] -top-[34px] transform -translate-y-1/2 cursor-pointer">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="#25314C" />
    </svg>
  </div>
);

const Dashboard = () => {

  const { t } = useTranslation();
  const { BaseUrl, ischnagelocation, setMapKey, catlist, setCatList } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState([]);
  const [dynmaicSection, setDynmaicSection] = useState([]);
  const [subcatSection, setSubcatSection] = useState([]);
  const [testimonial, setTestimonial] = useState([]);
  const [isprovidetext, setIsProvideText] = useState("");

  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1510,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings2 = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 1510, settings: { slidesToShow: 3 } },
      { breakpoint: 770, settings: { slidesToShow: 2 } },
      { breakpoint: 380, settings: { slidesToShow: 1 }, },
    ],
  };

  const Testimonial = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 1510, settings: { slidesToShow: 3 } },
      { breakpoint: 770, settings: { slidesToShow: 2 } },
      { breakpoint: 430, settings: { slidesToShow: 1 }, },
    ],
  };

  useEffect(() => {
    const Location = secureLocalStorage.getItem("selectlocation");
    setLoading(true);
    if (Location) {
      const { lat, long } = JSON.parse(Location);
      handleFetchData(lat, long);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;
        handleFetchData(lat, long);
      }
    )
  }, [ischnagelocation]);

  const handleFetchData = (lats, longs) => {
    const uid = secureLocalStorage.getItem("Userid") || "0";
    axios.post(`${BaseUrl}user_api/s_home_data`, { uid, lats, longs })
      .then((res) => {
        const { ResultData } = res.data;
        if (ResultData?.service_available === false) {
          setIsProvideText(ResultData.message);
        } else {
          setIsProvideText("");
        }
        setBanner(ResultData?.Banner);
        setCatList(ResultData?.Catlist);

        setDynmaicSection(ResultData?.Dynmaic_section);
        setSubcatSection(ResultData?.Subcat_section);
        setTestimonial(ResultData?.testimonial);
        setMapKey(ResultData?.g_key);
        secureLocalStorage.setItem("Catlist", JSON.stringify(ResultData?.Catlist));
        secureLocalStorage.setItem("currency", ResultData?.Main_Data.currency);
        secureLocalStorage.setItem("mapkey", ResultData?.Main_Data?.g_key);
        secureLocalStorage.setItem("contact", ResultData?.Main_Data.contact);
        secureLocalStorage.setItem("showhire", ResultData?.Main_Data.show_hire);
        secureLocalStorage.setItem("about", ResultData?.Main_Data.about);
        secureLocalStorage.setItem("policy", ResultData?.Main_Data.policy);
        secureLocalStorage.setItem("terms", ResultData?.Main_Data.terms);
        secureLocalStorage.setItem("zone_id", ResultData?.matched_zone_id);
        secureLocalStorage.setItem("wallet", ResultData?.wallet);
        secureLocalStorage.setItem("coordinates", JSON.stringify(ResultData?.zones_data));
        setLoading(false);
      })
      .catch((error) => {
        console.error("s_home_data", error);
      });
  }

  const handleGetDetails = (item) => {
    const title = item.cat_name || item.title;
    navigate("/details", { state: { path: "/", name: "Home" } });
    const LocalData = {
      title,
      cid: item.cat_id,
      sub_title: item.cat_subtitle,
      pid: "0"
    }
    secureLocalStorage.setItem("Productid", JSON.stringify(LocalData));
  }

  return (
    <div className='dashboard_page'>
      {loading
        ? <div className="w-full h-[calc(100vh-85px)] bg-white z-[777] fixed flex items-center justify-center">
          <div className="loader"></div>
        </div>
        : <div>
          <div className="width_container">
            <div className="section_1">
              <div style={{ width: isprovidetext && "100%" }} className="categori_box">
                <h1 className='font-[600] text-[36px] leading-[45px] max-_430_:text-[20px] max-_430_:leading-[25px]'>{t("Home services at your")} <br /> {t("doorstep")}</h1>
                <div className="main_box">
                  <h1 className="font-[600] text-[20px] text-[rgba(84,84,84,1.00)]">{t("What are you looking for?")}</h1>
                  {!isprovidetext
                    ? <div className="flex flex-wrap items-center gap-[14px] mt-[15px]">
                      {catlist?.map((item, index) => {
                        return <div key={index} onClick={() => handleGetDetails(item)} className="card_box">
                          <div className="bg-[#f5f5f5] rounded-[10px] py-[10px]">
                            <ImageLoad BaseUrl={BaseUrl} url={item.cat_img} CustomeStyle={"mx-auto w-[60px] h-[60px] object-contain"} />
                          </div>
                          <p className="text-center text-[14px] mt-[10px]">{item.cat_name}</p>
                        </div>
                      })}
                    </div>
                    : <div className="mt-[20px] text-center py-[20px]">
                      <h1 className="font-[600] text-gray-600 text-[18px]">{isprovidetext}</h1>
                    </div>}
                </div>
              </div>
              <div className="image_box">
                <img src="https://5.imimg.com/data5/SELLER/Default/2024/5/419308737/FJ/RY/LR/221893305/voltas-ac-repairing-services.png" className="h-full object-cover rounded-[10px]" alt="Logo" />
              </div>
            </div>

            {banner?.length >= 1 && <div className="pt-[20px]">
              {banner.length >= 2
                ? <div className="slider-container pb-[20px]">
                  <Slider {...settings}>
                    {banner?.map((item, index) => {
                      return <div key={index} onClick={() => handleGetDetails(item)} className="cursor-pointer outline-none">
                        <ImageLoad BaseUrl={BaseUrl} url={item.img} CustomeStyle={"w-full h-[200px] object-cover rounded-[15px]"} />
                      </div>
                    })}
                  </Slider>
                </div>
                : <div className="">
                  <img src={BaseUrl + banner[0].img} className="w-full bg-center h-[300px] object-cover rounded-[15px]" alt="img" />
                </div>
              }
            </div>}

            <div className="daymenic_section">
              {dynmaicSection?.map((item, index) => {
                return <div key={index} className="section_2">
                  <div className="leading-[25px] max-_430_:leading-[30px]">
                    <h1 className="title">{item.sec_title}</h1>
                    <p className="text-[15px] font-[500] text-gray-500 line-clamp-1">{item.sec_subtitle}</p>
                  </div>
                  <div className="slider-container mt-[10px]">
                    <Slider {...settings2}>
                      {item.service_data.map((data, dataindex) => {
                        return <div key={dataindex} onClick={() => handleGetDetails(data)} className="card_box">
                          <ImageLoad BaseUrl={BaseUrl} url={data.img} CustomeStyle={"w-full h-[220px] object-cover rounded-[10px]"} />
                          <div className="p-[10px]">
                            <h1 className="text-[15px] font-[500] line-clamp-1">{data.title}</h1>
                            <div className="flex items-center gap-[5px]">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="#25314C" />
                              </svg>
                              <p className="text-[14px]">{data.subtitle}</p>
                            </div>
                          </div>
                        </div>
                      })}
                    </Slider>
                  </div>
                </div>
              })}
            </div>

            <div className="subcat_section">
              {subcatSection?.map((item, index) => {
                if (index === 0) {
                  return <div key={index} className="section_3">
                    <div className="leading-[25px] max-_430_:leading-[30px]">
                      <h1 className="title">{item.cat_name}</h1>
                      <p className="text-[15px] font-[500] text-gray-500 line-clamp-1">{item.cat_subtitle}</p>
                    </div>
                    <div className="slider-container mt-[10px]">
                      <Slider {...settings2}>
                        {item.subcat_data.map((data, dataindex) => {
                          return <div key={dataindex} onClick={() => handleGetDetails(data)} className="card_box relative" >
                            <ImageLoad BaseUrl={BaseUrl} url={data.img} CustomeStyle={"w-full h-[300px] object-cover"} />
                            <div className="absolute top-0 z-[555] p-[10px]">
                              <h1 className="font-[500]">{data.title}</h1>
                              <p className="text-[14px] leading-4 line-clamp-3">{data.subtitle}</p>
                            </div>
                          </div>
                        })}
                      </Slider>
                    </div>
                  </div>
                } else {
                  return <div key={index} className="section_4">
                    <div className="leading-[25px] max-_430_:leading-[30px]">
                      <h1 className="title">{item.cat_name}</h1>
                      <p className="text-[15px] font-[500] text-gray-500 line-clamp-1">{item.cat_subtitle}</p>
                    </div>
                    <div className="slider-container mt-[10px]">
                      <Slider {...settings2}>
                        {item.subcat_data.map((data, dataindex) => {
                          return <div key={dataindex} onClick={() => handleGetDetails(data)} className="card_box">
                            <ImageLoad BaseUrl={BaseUrl} url={data.img} CustomeStyle={"w-full h-[220px] object-cover"} />
                            <div className="p-[10px]">
                              <h1 className="font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">{data.title}</h1>
                              <p className="text-[14px] leading-4 line-clamp-1">{data.subtitle}</p>
                            </div>
                          </div>
                        })}
                      </Slider>
                    </div>
                  </div>
                }

              })}
            </div>

            {testimonial?.length >= 1 && <div className="section_5">
              <div className="leading-[25px] max-_430_:leading-[30px]">
                <h1 className="title">World on the street</h1>
                <p className="text-[15px] font-[500] text-gray-500 line-clamp-1">Testimonial</p>
              </div>

              <div className="slider-container mt-[10px]">
                <Slider {...Testimonial}>
                  {testimonial?.map((item, index) => {
                    return <div key={index} className="card_box">
                      <div className="flex items-center gap-[10px]">
                        <ImageLoad BaseUrl={BaseUrl} url={item.img} CustomeStyle={"w-[60px] h-[60px] object-cover rounded-full"} />
                        <span className="text-[17px] font-[500] text-[#00c3ff]">{item.title}</span>
                      </div>
                      <p className="text-[14px] text-gray-800 leading-5 mt-[10px]">{item.comment}</p>
                    </div>
                  })}
                </Slider>
              </div>
            </div>}
          </div>
        </div>}
    </div>
  )
}

export default Dashboard;
/* jshint ignore:end */